export const CATALOG_SETTINGS_RESET_STATE = 'CATALOG_SETTINGS_RESET_STATE';
export const CATALOG_SETTINGS_CURRENT_ITEM = 'CATALOG_SETTINGS_CURRENT_ITEM';

export const CATALOG_SETTINGS_REQUEST_LOADING = 'CATALOG_SETTINGS_REQUEST_LOADING';
export const CATALOG_SETTINGS_REQUEST_SUCCESS = 'CATALOG_SETTINGS_REQUEST_SUCCESS';
export const CATALOG_SETTINGS_REQUEST_FAILED = 'CATALOG_SETTINGS_REQUEST_FAILED';

export const CATALOG_SETTINGS_CURRENT_ACTION = 'CATALOG_SETTINGS_CURRENT_ACTION';
export const CATALOG_SETTINGS_RESET_ACTION = 'CATALOG_SETTINGS_RESET_ACTION';
